import React, { ReactElement } from "react";

export const RenderDots: React.FC = () => {
  return (
    <div className="whats-new-dots" style={{ display: "inline-flex", columnGap: 16, justifySelf: "center" }}>
      {Array.from({ length: 3 }, (_, index) => (
        <div key={index} className="whats-new-dot" style={{backgroundColor: "#BC3323"}} />
      ))}
    </div>
  );
};

export const SecondTitleSection: React.FC = () => {

  return (
    <div className="whats-new-titles-container" style={{marginTop: 64, marginBottom: 64}}>
      <RenderDots />
      <h2 className="whats-new-version-title" style={{color: "#A03123", fontSize: 50}}>Latest Enhancements</h2>
      <h5 className="whats-new-version-title" style={{color: "#004680", fontSize: 35}}>Improvements Will Be Continuous. Stay Tuned.</h5>
    </div>
  );
};